import styled from 'styled-components'
import React, { Component } from 'react'
import Text from '../../atoms/Text/Text'
import media from 'styled-media-query'
import getOptimizedImage from '../../../utils/getOptimizedImage'
import CardHeading from '@/components/CardHeading'
import CardParagraph from '@/components/CardParagraph'

const Style = styled.div`
  /* height: 300px; */
  width: 100%;
  max-width: 400px;
  cursor: pointer;
  .play-icon {
    width: 50px;
    height: 50px;
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  ${media.lessThan('medium')`
    height: 400px;
    max-width: none;
    opacity: 1;
  `}
  &:hover {
    .thumb {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    }
  }

  .thumb {
    height: 200px;
    background-image: url(${(props) =>
      getOptimizedImage(props.thumbnail, 250)});
    background-position: center;
    background-size: cover;
    position: relative;
    border-radius: 12px;

    i {
      font-size: 60px;
      position: absolute;
      display: block;
      left: calc(50% - 30px);
      top: calc(50% - 30px);
      text-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);

      color: #ffffff;
    }

    ${media.lessThan('medium')`
    margin: 0 16px 10px 16px;
    height: 300px;
  `}
  }

  .content {
    margin: 8px 4px 0;
    ${media.lessThan('medium')`
      text-align: center;
      width: 100vw;
    `}
  }
`

export default class VideoCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: true
    }
  }
  render() {
    const { title, desc } = this.props
    return (
      <Style
        onClick={this.props.onClick}
        thumbnail={this.props.thumb}
      >
        <div className="thumb">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="play"
            className="play-icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="white"
              d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
            ></path>
          </svg>
        </div>
        <div className="content">
          <CardHeading tag="p">{title}</CardHeading>
          <CardParagraph>{desc}</CardParagraph>
        </div>
      </Style>
    )
  }
}
